module.exports = __webpack_public_path__ + "eb85cbef9796434c96d68df2af20850d.svg";